import { COLORS } from "@app/constants";
import BigNumber from "bignumber.js";
import React, { useContext } from "react";
import { Text, View } from "@/styles/reactnative";
import { ThemeContext } from "../../theme/ThemeProvider";
import { useWindowDimensions } from "../hooks";
import { useFetcherPublic } from "../hooks/fetcher";
import { getSetting, useSetting } from "../hooks/user/mysetting";
import { SETTING_TYPE_SYSTEM } from "../constants/SETTING";
import { useIsMobile } from '@utils/CalVW.tsx';
import { getBigNumber } from '@utils/getBigNumber.tsx';
import { truncateWithComma } from '@utils/Truncate.ts';

const KrwPrice = ({
  price = 0,
  dp = undefined,
  color = true,
  krw = true,
  margin = false,
  info24 = false,
  ratemargin = 0,
  theme = true,
  equiv = false,
  plusminus = "",
  equivcenter = false,
  krwprice = undefined,
  fontSize = undefined,
  subFontSize = undefined,
}: any) => {
  const { theme: themecolor } = useContext(ThemeContext);
  const { data: setting } = useSetting(SETTING_TYPE_SYSTEM);
  const settingCurrency = getSetting(setting, "CURRENCY", "USD");
  const isMobile = useIsMobile();

  const [currentPlusMinus, setCurrentPlusMinus] = React.useState(plusminus);
  const [currentPrice, setCurrentPrice] = React.useState(price);

  React.useEffect(() => {
    setCurrentPlusMinus(plusminus);
    setCurrentPrice(price);
  }, [plusminus, price]);

  const blueColor = COLORS.lightRed;
  const redColor = COLORS.lightGreen;

  const currencyList = useFetcherPublic("/system/currency");

  let equivusd = 1;
  if (equiv) {
    equivusd =
      currencyList?.data?.result?.result?.find(
        (item: any) => item?.code == settingCurrency
      )?.price || 1;
  }

  const { width } = useWindowDimensions();


  const getTextColor = () => {
    if (plusminus === "up") return redColor;
    if (plusminus === "down") return blueColor;
    if (color) {
      if (price < 0) return blueColor;
      if (price > 0) return redColor;
      return theme ? themecolor.COLORS.textw : "black";
    }
    return theme ? themecolor.COLORS.textw : "black";
  };

  return (
    <View
      style={{
        alignItems: "flex-start",
        fontSize: isMobile ? 15 : width < 1300 ? "0.8em" : "0.9em",
        fontWeight: 500,
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%",
        // width: '10vh',
        textAlign: "center",
      }}
    >
      {equiv ? (
        <View style={{ alignItems: "flex-start", display: 'flex', flexDirection: 'column', gap: '0px' }}>
          {price !== null && (
            <Text
              style={{
                justifyContent: "flex-end",
                marginRight: margin ? 10 : 0,
                fontSize: fontSize ?? (info24 ? "20px" : width < 1300 ? "0.8em" : "1em"),
                fontWeight: 500,
                whiteSpace: "nowrap",
                letterSpacing: -0.6,
                marginTop: isMobile ? "5px" : '0',
                color: getTextColor(),
                lineHeight: 1.2,
              }}
            >
              {truncateWithComma(BigNumber(price).toNumber(), dp || 2) + (krw ? " USDT" : "")}
            </Text>
          )}
          {ratemargin > 0 && (
            <Text
              style={{
                fontSize: subFontSize ?? (width < 1300 ? "0.75em" : "0.9em"),
                whiteSpace: "nowrap",
                lineHeight: 1.2,
                color: color
                  ? price < 0
                    ? blueColor
                    : price > 0
                    ? redColor
                    : theme
                    ? themecolor.COLORS.textw
                    : "black"
                  : theme
                  ? themecolor.COLORS.textw
                  : "black",
              }}
            >
              (
              {BigNumber(+price)
                .dividedBy(ratemargin)
                .multipliedBy(100)
                .toFormat(2)}
              %)
            </Text>
          )}
          <Text
            style={{
              width: '100%',
              justifyContent: "flex-start",
              marginRight: margin ? 10 : 0,
              fontSize: subFontSize ?? "12px",
              fontWeight: 500,
              whiteSpace: "nowrap",
              letterSpacing: -0.6,
              lineHeight: 1.2,
              color: themecolor.COLORS.Tertiary,
            }}
          >
            {price
              ? "≒ " +
                BigNumber(price).multipliedBy(equivusd).toFormat(0) +
                " " +
                settingCurrency
              : "-"}
          </Text>
        </View>
      ) : (
        <View style={{ alignItems: "center", marginRight: 2 }}>
          <Text
            style={{
              justifyContent: "flex-end",
              marginRight: margin ? 10 : 0,
              // fontSize: width < 1300 ? "14px" : "1em",
              fontSize: fontSize ?? "12px",
              fontWeight: 500,
              whiteSpace: "nowrap",
              letterSpacing: -0.6,
              color: color
                ? price < 0
                  ? blueColor
                  : price > 0
                  ? redColor
                  : theme
                  ? themecolor.COLORS.textw
                  : "black"
                : theme
                ? themecolor.COLORS.numberText
                : "black",

            }}
          >
            {price
              ? truncateWithComma(BigNumber(price).toNumber(), dp || 2) + (krw ? " USDT" : "")
              : ""}
          </Text>
          {ratemargin > 0 && (
            <Text
              style={{
                fontSize: subFontSize ?? (width < 1300 ? "1em" : "1em"),
                whiteSpace: "nowrap",
                color: color
                  ? price < 0
                    ? blueColor
                    : price > 0
                    ? redColor
                    : theme
                    ? themecolor.COLORS.textw
                    : "black"
                  : theme
                  ? themecolor.COLORS.textw
                  : "black",
              }}
            >
              (
              {BigNumber(price)
                .dividedBy(ratemargin)
                .multipliedBy(100)
                .toFormat(2)}
              %)
            </Text>
          )}
        </View>
      )}
    </View>
  );
};

export default React.memo(KrwPrice);
